import { NgModule } from '@angular/core';
import { AgmSnazzyInfoWindow } from './directives/snazzy-info-window';
var AgmSnazzyInfoWindowModule = (function () {
    function AgmSnazzyInfoWindowModule() {
    }
    return AgmSnazzyInfoWindowModule;
}());
export { AgmSnazzyInfoWindowModule };
AgmSnazzyInfoWindowModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AgmSnazzyInfoWindow],
                exports: [AgmSnazzyInfoWindow]
            },] },
];
/** @nocollapse */
AgmSnazzyInfoWindowModule.ctorParameters = function () { return []; };
//# sourceMappingURL=snazzy-info-window.module.js.map


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/@agm/snazzy-info-window/snazzy-info-window.module.js.pre-build-optimizer.js